// extracted by mini-css-extract-plugin
export default {"custom-toast":"Notifier_custom-toast__nFx1K","custom-toast-body":"Notifier_custom-toast-body__zbSF6"};